import { differenceInDays, format, isPast, startOfDay } from "date-fns";
import { nb } from "date-fns/locale";

import type { HNOppgaveFrontend } from "../types/Resources";

export const createDateString = (
  dato: Date | string | null | undefined,
  datoFormat: string,
): string => {
  if (!dato) {
    return "";
  }

  const parsedDato = typeof dato === "string" ? new Date(dato) : dato;

  if (!(parsedDato instanceof Date) || isNaN(parsedDato.getTime())) {
    return "";
  }

  return format(parsedDato, datoFormat, { locale: nb });
};

export const createDateString_deadline = (
  resources: HNOppgaveFrontend | undefined,
  oppgaveFristDato: Date | string | null | undefined,
): string => {
  if (!oppgaveFristDato) {
    return "";
  }

  const fristDato =
    typeof oppgaveFristDato === "string"
      ? new Date(oppgaveFristDato)
      : oppgaveFristDato;

  if (!(fristDato instanceof Date) || isNaN(fristDato.getTime())) {
    return "";
  }

  const formattedDate = format(fristDato, "dd.MM.yyyy", { locale: nb });
  if (!resources) {
    return formattedDate;
  }

  const todayStartOfDay = startOfDay(new Date());
  const fristStartOfDay = startOfDay(fristDato);
  const diffDays = Math.abs(differenceInDays(todayStartOfDay, fristStartOfDay));
  const hasDatePassed = isPast(fristDato);

  if (diffDays === 0) {
    return `${resources.dateString_today}`;
  }
  if (hasDatePassed) {
    return `${formattedDate}`;
  }
  if (diffDays === 1) {
    return `${resources.dateString_preposition} ${diffDays} ${resources.dateString_day} (${formattedDate})`;
  }
  return `${resources.dateString_preposition} ${diffDays} ${resources.dateString_days} (${formattedDate})`;
};
